module.exports = __webpack_public_path__ + "img/bg16.59c76299.png";